import { IEnvelopeList, ISort } from '../common/types';
import { AxiosResponse } from 'axios';
import { formatSortingFields } from '../common/helpers';
import { ApiService } from '../../services';
import endpoints from '../../constants/endpoints';
import {
	IBranchOfficeList,
	IBranchOfficeNotPhysicalBranch,
	IBranchOfficePhysicalBranch,
	INetsuiteAccount,
} from './types';

export const getBranchOfficeList = async (
	page = 0,
	size = 10,
	sortingFields: ISort[],
	filters?: Record<string, string | number | boolean>,
): Promise<AxiosResponse<IEnvelopeList<IBranchOfficeList>>> => {
	const sorts = formatSortingFields(sortingFields);
	return ApiService.get(endpoints.branchOfficesPageList, {
		params: {
			page,
			size,
			...(sorts.length > 0 && { sort: sorts }),
			...(filters && filters),
			envelope: true,
		},
	});
};

export const getBranchOffice = async (
	id: number,
): Promise<AxiosResponse<IBranchOfficePhysicalBranch | IBranchOfficeNotPhysicalBranch>> => {
	return ApiService.get(endpoints.getBranchOffice.replace(':id', id + ''));
};

export const getNetsuiteAccounts = async (): Promise<AxiosResponse<INetsuiteAccount[]>> => {
	return ApiService.get(endpoints.getAllNetsuiteAccountsForAgency);
};

export type BranchOfficeUpsert = IBranchOfficePhysicalBranch | IBranchOfficeNotPhysicalBranch;

export const createBranchOffice = async (payload: BranchOfficeUpsert): Promise<AxiosResponse<void>> => {
	return ApiService.post(endpoints.createBranchOffice, payload);
};

export const updateBranchOffice = async (id: number, payload: BranchOfficeUpsert): Promise<AxiosResponse<void>> => {
	return ApiService.put(endpoints.updateBranchOffice.replace(':id', String(id)), payload);
};
